// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"d6883c8a","354":"dbdad48c","427":"993256af","568":"6482172d","968":"3ea2f615"}[chunkId] + ".chunk.js";
};